import { render, staticRenderFns } from "./MarketplaceService.vue?vue&type=template&id=6523158b&scoped=true"
import script from "./MarketplaceService.vue?vue&type=script&lang=js"
export * from "./MarketplaceService.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceService.vue?vue&type=style&index=0&id=6523158b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6523158b",
  null
  
)

export default component.exports